module.exports = "<div class=\"Block\">\r\n  <input type='file' (change)=\"fileChanged($event)\">\r\n</div>"